import { AnnualEnrollmentKey } from '../../annual-enrollment/models/annual-enrollment-models';
import { NewHireEnrollmentRoutes } from '../../arc/features/new-hire-enrollment/models/new-hire-routes';
import { NewHireProps, AnnualEnrollmentProps } from '../../arc/models/arc-epi-props';
import { AccountInfoRoutes } from '../constants/routes';

export interface GenericFormButtonActionText {
	continue: string;
	back: string;
}

export function GetNavigationButtonText(
	enrollmentContext: AnnualEnrollmentKey,
	newHireProps: NewHireProps,
	annualEnrollmentSettings: AnnualEnrollmentProps,
	isMember: boolean,
	customNextStep: boolean,
	isLifeEventCoverageForm?:boolean,
): GenericFormButtonActionText {

	if (enrollmentContext === AnnualEnrollmentKey.dioApproverEnrollment)
		return {
			continue: isLifeEventCoverageForm ? newHireProps?.continueToCoverageButtonText : newHireProps?.continueToEmploymentCompButtonText,
			back: newHireProps?.backToPersonalInfoButtonText,
		};

	if (enrollmentContext === AnnualEnrollmentKey.newHireEnrollment)
		return (isMember && !customNextStep) ? {
			continue: newHireProps?.continueToEmploymentCompButtonText,
			back: newHireProps?.backToPersonalInfoButtonText,
		} : {
			continue: newHireProps?.benefitEnrollmentRelationshipContinueText,
			back: newHireProps?.benefitEnrollmentRelationshipBackText,
		};

	return {
		continue: annualEnrollmentSettings?.relationshipNextButtonText,
		back: annualEnrollmentSettings?.relationshipPreviousButtonText,
	};

}


export function GetNextStepRedirect(isMember: boolean, coverageNextStep: boolean, basePath: string) {
	if (coverageNextStep) {
		return `${basePath}${NewHireEnrollmentRoutes.Coverage}`;
	}
	return isMember ? `${basePath}${AccountInfoRoutes.EmploymentSegment}` : `${basePath}${NewHireEnrollmentRoutes.Pension}`;

}